module.exports = __webpack_public_path__ + "img/1-3.3f3b20a5.svg";